import './style/projects.css'
import './style/images.css'

// images
import AudioCtxIcon from './img/proj/audiocontexticon.jpg';
import FilmoraIcon from './img/vis/filmoraicon.png';

import {
    Link,
    Switch,
    Route,
    BrowserRouter as Router,
    useRouteMatch,
    useParams
} from 'react-router-dom';

import {ImageGallery} from './ImageGallery.jsx';

function lockBg(){
    const bg = document.getElementsByTagName("BODY")[0];
    bg.classList.remove("yesScroll")
    bg.classList.add("noScroll")
}

function unlockBg(){
    const bg = document.getElementsByTagName("BODY")[0];
    bg.classList.remove("noScroll")
    bg.classList.add("yesScroll")

}

function Visual() {
    let {path, url} = useRouteMatch();

    return (
        <div>

        <div className="visualMenuTop">
            <p className="subheader gradient">Visual</p>
            <p>
                This website focuses on my <b>design research</b> work. However, I also had a previous career in visual design, mainly in <b>video</b> and <b>illustration</b>.
                <br/>
                A high level survey of my work is shown here.
            </p>
            <p></p>
            <hr></hr>
            <p>
                <span className="subheader">Video</span>
                <br/>
            </p>
        </div>
            <p>
                <InlineVideo
                    clientName="Wondershare Filmora"
                    role="Director of Photography"
                    embedURL="https://www.youtube.com/embed/qlSJ1vJ66iI"
                />
            </p>
            <p>
                <InlineVideo
                    clientName="April Fools Childrenhood"
                    role="Director / VFX"
                    embedURL="https://www.youtube.com/embed/ermbZmipxIs"
                />
            </p>
            <p>
                <InlineVideo
                    clientName="University of British Columbia"
                    role="character illustration, animation revisionist"
                    embedURL="https://www.youtube.com/embed/l2X1grXxNe8"
                />
            </p>
            <div className="visualMenuTop">
                <p>
                    <span className="subheader">Illustration</span>
                    <br/>
                </p>

                <p>
                    <InlineIllustration
                        hide={true}
                        image="https://www.dvdmrn.xyz/illustration/bear2.png"
                    />
                </p>
                
                <p>
                    <InlineIllustration
                        hide={true}
                        image="https://www.dvdmrn.xyz/illustration/nek-wide.png"
                    />
                </p>

                <p>
                    <InlineIllustration
                        hide={true}
                        image="https://leftoversalad.com/c/015_programmingpeople/PP4.png"
                    />
                </p>
            </div>
            <InlineIllustration
                clientName="The Tyee"
                image="https://thetyee.ca/News/2021/05/11/GlacialEcosystemStoryPanel.jpg"
            >

                I created the illustrations in the following articles: <br></br>
                <ul>
                    <li>
                        <a href="https://thetyee.ca/big-melt/" target="_blank">The Big Melt</a>
                    </li>
                    <li>
                        <a href="https://thetyee.ca/News/2021/05/12/How-Big-Melt-Will-Change-Life-People-Nature/" target="_blank">How The Big Melt Will Change Life for People and Nature</a>
                    </li>
                </ul>
            </InlineIllustration>
            <p>
            </p>
            
        {/* 

            <div className="visualMenuMid">
            <hr></hr>
            <p>
                <span className="subheader">Illustration</span>
                <br></br> Here are some illustrations I've done
            </p>
            



        </div>*/}
        </div> 

    )
}

function ProjectIcon(props){
    return(
        <div className="projectContainer" onClick={lockBg}>
            <img src={props.img} className="projButtonImage" />
            <div className="innerProjButton">
                <b>{props.title}</b>
                <br></br>
                <span className="secondary">{props.desc}</span><p></p>
                    {props.children}
            </div>
        </div>
    )
}


function ProjectPage(props){
    return(
        <div>
            <Link to='/visual'> 
            <div className="projectPageContainer" onClick={unlockBg}></div>
            </Link>
                
            <div className="projectPageMenu">
                <Link to='/visual'><CloseButton /></Link>
                <div className="subheader projectTitle">{props.title}</div>
                    <div className="projectBody">
                        {props.children}
                    </div>
            </div>
        </div>
    )
}

function CloseButton(){
    return(
        <div className="xButton"
             onClick={unlockBg}>
            x
        </div>
    )
}

function InlineVideo(props){
    return(
        <div className="inlineVideo">
            <p>
                <div className="videoInfo">
                    <b>Client: </b> {props.clientName} <br></br>
                    <b>Role: </b> {props.role}
                        </div>

            </p>
            <center>
                <iframe src={props.embedURL}
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                    className="inlineVideoContent">
                </iframe>
            </center>

        </div>
    )
}

function InlineIllustration(props) {
    return (
        <div className="inlineVideo">
            <p>
                <div className="videoInfo">
                    {props.hide ? '' : (<><b>Client: </b> {props.clientName}</>) }
                </div>

            </p>
            <center>
                <img src={props.image} width="100%"/>
            </center>

            {props.children}

        </div>
    )
}

export { Visual }